import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router";
import { VernostServiceService } from "../../../services/vernost-service.service";
import { CommonService } from "../../../services/common.service";

@Component({
  selector: 'app-ancellaries-description',
  templateUrl: './ancellaries-description.component.html'
})
export class AncellariesDescriptionComponent implements OnInit {
  rejected = 0;
  offSubmit = false;
  namePresent = false;
  codePresent = false;
  adAuto_msg;
  nameExist1 = false;
  data_present = false;
  items: any = [];
  minRemark = false;
  timer;
  edit: any;
  exceedLength1 = false;
  minlength1 = false;
  notAlphabet1 = false;
  countries: any[];
  USER_ID = 1; //plse make it dyanamic
  changedData = [];
  filteredResponseList: any = [];
  parentTableName = "mst_country";
  parentTableName1 = "mst_city";
  // count1 = 0;
  // count2 = 0;
  // count3 = 0;
  //insert table name
  searchDBColumnName = ["COUNTRY_NAME", "COUNTRY_CODE"];
  searchDBColumnName1 = ["CITY_NAME", "CITY_CODE"];
  like = "COUNTRY_NAME";
  like1 = "CITY_NAME";
  adFormstatusdata = [];
  formstatusdata1 = [];
  adAutoArray: any = [];
  autoArray1: any = [];
  ccode1;
  ccode2;
  ccode3;
  disablestatus = false;
  isApproved = false;
  hide = false;
  gotoChangeStatus = true;
  approveStatus;
  aprvbtn = false;
  updateApprove = false;
  forupdate = false;
  STAT = 1;
  onlyspaces = false;
  onlyspclchar = false;
  adSearchresult: boolean = false;
  mincityname = false;
  onlynum = false;
  cnameExceed = false;
  invalidCityName = false;
  minlength = false;
  searchlist: boolean = true;
  exceedLength = false;
  notAlphabet: boolean = false;
  showApprove = false;
  viewPageDetails = [];
  previousData: any = [];
  validatorArray: any = [];
  viewpage = false;
  dblclick = false;
  adLoader: any = false;
  nameExist = false;
  showList: boolean = false;
  screentitle: string = "Ancillaries Description";
  actionmode: string = "Seacrh";
  parent_table = "mst_ancillaries_description";
  parent_table_ID = "AI_ID";
  TYPE = "TYPE";
  DESCRIPTION = "DESCRIPTION";
  Parent_result_ID = "";
  ctryname;
  dbFields = [
    this.TYPE,
    this.DESCRIPTION
  ];

  dbFields1 = [this.TYPE,
  this.DESCRIPTION];
  searchitem = " ";
  searchColumn = " ";
  childtables = [];
  filters = [];
  filters1 = [];
  screen_details: any = [];
  priviousData: any = [];
  search_details: any = [];
  adSearchtabledata: any = [];
  combo_details1: any = [];
  data: any = [];
  status: any = {};
  sortType = "";
  p: number = 1;
  codePattern = "^[A-Z]{1,3}$";
  namePattern = "^([a-zA-Z\u0080-\u024F]+(?:. |-| |'))*[a-zA-Z\u0080-\u024F]*$";
  citycodepatrn = "^[A-Z]{3}$";
  // APPROVAL_STATUS = "APPROVAL_STATUS";
  APPROVAL_REMARKS = "APPROVAL_REMARKS";
  APPROVAL_BY = "APPROVAL_BY";
  aprove_details: any = [];
  uid = "";
  aprovebtn: boolean = true;
  rejectbtn: boolean = true;
  roleID = "";
  fid = "";
  RAC_VIEW = "";
  RAC_ADD = "";
  RAC_EDIT = "";
  RAC_APROVE = "";
  editedData1: any = "";
  constructor(
    private vernostService: VernostServiceService,
    private commonService : CommonService,
    private router: Router
  ) { }

  ngOnInit() {
    this.uid = localStorage.getItem("uid");
    this.roleID = localStorage.getItem("roleID");
    this.fid = localStorage.getItem("fid");
    if (this.uid == "" || this.uid == undefined) {
      this.router.navigate(["/login"]);
    }
    var rollArrayAncillary = {
      funId: this.fid,
      roleID: this.roleID
    };

    this.vernostService.checkFunAccess(rollArrayAncillary).subscribe(response => {
      this.RAC_VIEW = JSON.stringify(response[0].addinfo[0].RAC_VIEW);
      this.RAC_ADD = JSON.stringify(response[0].addinfo[0].RAC_ADD);
      this.RAC_EDIT = JSON.stringify(response[0].addinfo[0].RAC_EDIT);
      this.RAC_APROVE = JSON.stringify(response[0].addinfo[0].RAC_APROVE);
    });
    this.screen_details = {
      TYPE: "",
      DESCRIPTION: ""
    };
    this.addCombo(this.childtables[0], this.filters[0]);
    this.search_details = {
      TYPE: "",
    };
    this.showList = false;
    this.vernostService.getValidator().subscribe(response => {
      this.validatorArray = response;

      //alert(this.validatorArray.City_Master.City_Name[1]);
      this.ccode1 = this.validatorArray.City_Master.City_Code[1];
      this.ccode2 = this.validatorArray.City_Master.City_Code[2];
      this.ccode3 = this.validatorArray.City_Master.City_Code[3];
    });
  }
  checkAproval() {
    // this.aprovebtn="";
    var dbField = [""];
    var arrayAncillary = {
      dbField: dbField,
      parent_table: this.parent_table,
      parent_table_ID: this.parent_table_ID,
      formdataId: this.Parent_result_ID
    };
    this.vernostService.checkAproval(arrayAncillary).subscribe(response => {
      //   alert(JSON.stringify(response[0].addinfo[0].APPROVAL_STATUS));
      var status = JSON.stringify(response[0].addinfo[0].APPROVAL_STATUS);
      var stat = parseInt(status);
      if (stat == 1) {
        this.aprovebtn = false;
        this.rejectbtn = true;
      }
      if (stat == 2) {
        this.rejectbtn = false;
        this.aprovebtn = true;
      } else {
        this.aprovebtn = true;
        this.rejectbtn = true;
      }
    });
  }


  changeName() {
    var dataAncillary = {
      parent_table: this.parent_table,
      formData: this.Parent_result_ID,
      columnName: "CITY_ID"
    };

    this.vernostService.getSTATUS(dataAncillary).subscribe(response => {
      // this.approveStatus = 0;
      // this.searchData

      this.approveStatus = response[0].status;
      if (this.isApproved && this.actionmode == "Edit") {
        this.checkColor();
      }
    });
  }

  gotochangestatus() {
    if (this.actionmode == "Edit") {
      var dataAncillary = {
        parent_table: this.parent_table,
        formData: this.Parent_result_ID,
        columnName: this.parent_table_ID
      };

      this.vernostService.editstatus(dataAncillary).subscribe(response => {
       
        this.isApproved = false;
      });
    }
  }

/**
 * No Reference Found for this code. Pls re-check before deleting - Gaurav
 */

  /*changeBtnColor(id, status) {
    if (status == 1) {
      status = 0;
    } else if (status == 0) {
      status = 1;
    }

    var dataAncillary = {
      parent_table: this.parent_table,
      formData: id,
      columnName: "CITY_ID",
      status: status
    };

    this.vernostService.changeSTATUS(dataAncillary).subscribe(response => {
      this.searchData();
    });
  }*/

  checkColor() {
    let approveStatus = this.approveStatus;
    this.commonService.checkColor(approveStatus,'ancellaries-description');
  }

  aproveReject(status) {
    if (!this.nameExist1) {
      this.isApproved = true;
      var currentTime = new Date();
      var dbFieldAncellaryDescription = [
        "",
        this.APPROVAL_REMARKS,
        this.APPROVAL_BY,
        "STATUS",
        "APPROVAL_DATE_TIME"
      ];
      if (status == 1) {
        this.approveStatus = 1;
      }
      var formDataAncellaryDescription = [
        status,
        this.aprove_details.APPROVAL_REMARKS,
        this.uid,
        status,
        currentTime
      ];
      var arrayAncillary = {
        dbField: dbFieldAncellaryDescription,
        parent_table: this.parent_table,
        formData: formDataAncellaryDescription,
        parent_table_ID: this.parent_table_ID,
        formdataId: this.Parent_result_ID
      };

      this.vernostService.aproveReject(arrayAncillary).subscribe(response => {
        this.aprove_details.APPROVAL_REMARKS = "";
        if (status == 2) {
          this.rejected = 2;
          //this.searchForm();
          //this.searchData();

        } else {
          if (this.isApproved && this.actionmode == "Edit") {
            this.checkColor();
          }
          if (response[0].aproval == "aproved") {
            this.aprvbtn = false;
            // this.aprovebtn=false;
            //  alert(JSON.stringify(response[0].status));
            //  this.searchForm();
          }
          this.aprvbtn = false;
        }
        // this.setlog("AppRej", status);
        if (this.actionmode == "Edit") {
          this.submitData1();
        }
        this.searchData();
      });
    }
  }

  setId(id) {
    this.Parent_result_ID = id;
  }


  /*
  sortByOrder(data, number_ancillary) {
    if (number_ancillary == 1) {
      if (this.count1 % 2 == 0) {
        this.sortType = "ASC";
      } else {
        this.sortType = "DESC";
      }
      this.count1++;
      this.count2 = 0;
      this.count3 = 0;
    }
    if (number_ancillary == 2) {
      if (this.count2 % 2 == 0) {
        this.sortType = "ASC";
      } else {
        this.sortType = "DESC";
      }
      this.count2++;
      this.count1 = 0;
      this.count3 = 0;
    }
    if (number_ancillary == 3) {
      if (this.count3 % 2 == 0) {
        this.sortType = "ASC";
      } else {
        this.sortType = "DESC";
      }
      this.count3++;
      this.count1 = 0;
      this.count2 = 0;
    }
    var arrayAncillary = {
      sortField: data,
      parent_table: this.parent_table,
      childtables: this.childtables,
      filters: this.filters,
      sortType: this.sortType,
      dbFields: this.searchColumn,
      searchData: this.searchitem
    };
    this.vernostService.sortByOrder(arrayAncillary).subscribe(response => {
      this.adSearchtabledata = response;
    });
  } */

  addForm() {
    this.rejected = 0;
    this.data_present = false;
    this.nameExist = false;
    this.nameExist1 = false;
    this.screen_details = {
      CITY_CODE: "",
      CITY_NAME: "",
      COUNTRY_CODE: "0"
    };
    this.exceedLength1 = false;
    this.notAlphabet1 = false;
    this.exceedLength1 = false;
    this.notAlphabet1 = false;
    this.Parent_result_ID = "";
    this.forupdate = false;
    this.showList = false;
    this.actionmode = "Add";
    this.mincityname = false;
    this.onlynum = false;
    this.cnameExceed = false;
    this.invalidCityName = false;
    this.minlength = false;
    this.updateApprove = false;
    this.exceedLength = false;
    this.notAlphabet = false;
    this.search_details = {
      CITY_CODE: "",
      CITY_NAME: "",
      COUNTRY_NAME: ""
    };
    document.getElementById("errs").innerHTML = "";
  }
  openfileDialog() {
    document.getElementById("fileLoader").click();
  }
  searchForm() {
    this.rejected = 0;
    if (this.actionmode != "Edit") {
      this.searchData();
    } else {
      this.search_details.CITY_CODE = "";
      this.search_details.CITY_NAME = "";
      this.adSearchresult = false;
    }
    this.data_present = false;
    this.nameExist = false;
    this.nameExist1 = false;
    this.screen_details = {
      CITY_CODE: "",
      CITY_NAME: "",
      COUNTRY_CODE: "0"
    };

    this.actionmode = "Search";
    this.viewpage = false;
    this.showList = false;
    this.showApprove = false;
    this.updateApprove = false;
    this.mincityname = false;
    this.onlynum = false;
    this.cnameExceed = false;
    this.invalidCityName = false;
    this.minlength = false;
    this.notAlphabet = false;
    this.nameExist = false;
    this.onlyspclchar = false;

    //this.searchData();
    // if (this.forupdate) {
    //   document.getElementById("errs").innerHTML = "Record updated Successfully";

    //   setTimeout(function() {
    //     document.getElementById("errs").innerHTML = "";
    //     document.getElementById("errs").style.background = "#ebccd1";
    //     document.getElementById("errs").style.color = "#a94442";
    //   }, 3000);
    //
    document.getElementById("errs").innerHTML = "";
  }
  showFormData(formData, toggle) {
    //    document.getElementById("errs").innerHTML = "";

    if (toggle == "2") {
      this.updateApprove = true;
      this.showList = false;
      this.actionmode = "Edit";

    }

    this.Parent_result_ID = formData;
    var array = {
      parent_table: this.parent_table,
      dbFields: this.dbFields,
      parent_table_ID: this.parent_table_ID,
      formData: formData
    };
    this.vernostService.getData(array).subscribe(response => {
      this.screen_details = {
        TYPE: response[0].result[0].TYPE,
        DESCRIPTION: response[0].result[0].DESCRIPTION
      };

      this.editedData1 = response[0].result[0].DESCRIPTION;
      this.viewPageDetails = response[0].result;
      // this.previousData = response[0].result;
      // this.approveStatus = response[0].result[0].STATUS;

      if (toggle == "1") {
        this.viewpage = true;

        this.actionmode = "Add";
        if (!this.showApprove) {
          this.showList = true;
        } else {
          this.showList = false;
        }

        var parent_table = "mst_ancillaries_description";
        var childtables = [];
        var datalike = ["TYPE"];
        var dbFields = ["TYPE"];
        var findData = [this.screen_details.TYPE];

        var dataAncillary = {
          parent_table: parent_table,
          childtables: childtables,
          datalike: datalike,
          dbFields: dbFields,
          findData: findData
        };

        this.vernostService.searchRecordById(dataAncillary).subscribe(searchResponse => {
        });
      }
      if (toggle == "2") {
        if (this.isApproved && this.actionmode == "Edit") {
          this.checkColor();
        }
      }
    });
  }
  addCombo(childtable, dbField) {
    var array = {
      childtable: childtable,
      dbField: "COUNTRY_NAME"
    };
    this.vernostService.getComboData1(array).subscribe(response => {
      if (response[0].status == this.childtables[0]) {
        this.combo_details1 = response[0].result;
      }
    });
  }

  // clearAuto() {
  //   this.formstatusdata1 = [];
  // }

  // clearAuto1() {
  //   this.formstatusdata = [];
  // }

  autoCompleteSearch(event) {
    document.getElementById("errs").innerHTML = "";
    var data = {
      inputSearchString: event,
      parentTableName: this.parentTableName,
      searchDBColumnName: this.searchDBColumnName,
      like: this.like
    };
    if (event.length < 3) {
      this.adAuto_msg = "";
    }
    if (event.length >= 3) {
      this.adFormstatusdata = [];
      this.vernostService.getRecords(data).subscribe(response => {
        this.adAutoArray = response;

        let value = new Array();
        for (let i = 0; i < this.adAutoArray.length; i++) {
          value[i] = {
            value: this.adAutoArray[i].COUNTRY_NAME,
            label: this.adAutoArray[i].COUNTRY_NAME
          };
          this.adFormstatusdata = value.slice(0);
        }

        if (this.adAutoArray.length <= 0 && event.length >= 3) {
          this.adAuto_msg = "No result found";
        } else {
          this.adAuto_msg = "";
        }
      });
    } else {
      this.adFormstatusdata = [];
    }
  }

  autoCompleteSearch1(event) {
    // this.formstatusdata1 = [];
    // this.autoArray1 = [];

    document.getElementById("errs").innerHTML = "";

    var data = {
      inputSearchString: event,
      parentTableName: this.parentTableName1,
      searchDBColumnName: this.searchDBColumnName1,
      like: this.like1
    };
    if (event.length < 3) {
      this.adAuto_msg = "";
    }
    if (event.length >= 3) {
      this.vernostService.getRecords(data).subscribe(response => {
        this.autoArray1 = response;

        let value = new Array();
        for (let i = 0; i < this.autoArray1.length; i++) {
          value[i] = {
            value: this.autoArray1[i].CITY_NAME,
            label: this.autoArray1[i].CITY_NAME
          };
          this.formstatusdata1 = value.slice(0);
        }
        if (this.autoArray1.length <= 0 && event.length >= 3) {
          this.adAuto_msg = "No result found";
        } else {
          this.adAuto_msg = "";
        }
      });
    } else {
      this.formstatusdata1 = [];
    }
  }
  keyupHandler1(e) {
    this.screen_details.DESCRIPTION = e;
    // console.log("this.screen_details",this.screen_details);
  }
  // setlog(action, fieldS) {
  //   //alert("in set");
  //   let ischange = false;
  //   let newData: any = [];
  //   //  this.previousData = [];
  //   this.changedData = [];

  //   let pid = this.Parent_result_ID;
  //   if (action == "EDIT") {
  //     newData = {
  //       CITY_CODE: fieldS[0],
  //       CITY_NAME: fieldS[1],
  //       COUNTRY_CODE: fieldS[2]
  //     };

  //     if (this.previousData[0].CITY_CODE != fieldS[0]) {
  //       this.changedData.push({ CITY_CODE: fieldS[0] });
  //       ischange = true;
  //     }
  //     if (this.previousData[0].CITY_NAME != fieldS[1]) {
  //       this.changedData.push({ CITY_NAME: fieldS[1] });
  //       ischange = true;
  //     }
  //     if (this.previousData[0].COUNTRY_CODE != fieldS[2]) {
  //       this.changedData.push({ COUNTRY_CODE: fieldS[2] });
  //       ischange = true;
  //     }

  //     let data = {
  //       TABLE_NAME: "mst_city",
  //       ROCORD_ID: pid,
  //       ACTION: action,
  //       PRE_RECORD: this.previousData,
  //       NEW_RECORD: newData,
  //       CHANGED_RECORD: this.changedData,
  //       MODIFIED_BY: this.USER_ID
  //     };

  //     if (ischange) {
  //       this.vernostService.setAuditLog(data).subscribe(response => {
  //         //this.dblclick = false;
  //         //this.forupdate = true;
  //         //alert(JSON.stringify(response[0].status));
  //         // this.searchForm();
  //       });
  //     }
  //   }
  //   if (action == "AppRej") {
  //     let prev_Data: any = [];

  //     prev_Data = [{ APPROVAL_STATUS: 0 }];

  //     var status = fieldS;

  //     if (status == 1) {
  //       newData = { APPROVAL_STATUS: 1 };
  //       action = "APPROVE";
  //       this.changedData.push({ APPROVAL_STATUS: 1 });
  //       ischange = true;
  //     }
  //     if (status == 2) {
  //       action = "REJECT";
  //       newData = { APPROVAL_STATUS: 2 };
  //       this.changedData.push({ APPROVAL_STATUS: 2 });
  //       ischange = true;
  //     }

  //     let data = {
  //       TABLE_NAME: "mst_city",
  //       ROCORD_ID: pid,
  //       ACTION: action,
  //       PRE_RECORD: prev_Data,
  //       NEW_RECORD: newData,
  //       CHANGED_RECORD: this.changedData,
  //       MODIFIED_BY: this.USER_ID
  //     };

  //     if (ischange) {
  //       this.vernostService.setAuditLog(data).subscribe(response => {
  //       });
  //     }
  //   }
  // }

  duplicate() {
    alert("yoyoyo");
  }
  submitdata() {
    this.offSubmit = false;
    this.dblclick = true;
    // console.log("Parent_result_ID", this.Parent_result_ID)
    if (
      this.screen_details.TYPE == "" ||
      this.screen_details.TYPE == undefined ||
      this.screen_details.DESCRIPTION == "" ||
      this.screen_details.DESCRIPTION == undefined
    ) {
      document.getElementById("errs").innerHTML = "Please fill all data";

      this.dblclick = false;
    } else {
      //  this.priviousData = this.screen_details;
      var formData = [
        this.screen_details.TYPE,
        this.screen_details.DESCRIPTION
      ];

      if (this.Parent_result_ID != "") {
        // alert(JSON.stringify(this.previousData));
        // alert(JSON.stringify(formData));

        var array = {
          parent_table: this.parent_table,
          dbFields: this.dbFields1,
          parent_table_ID: this.parent_table_ID,
          formData: formData,
          formdataId: this.Parent_result_ID,
          USER_ID: this.uid
        };

        this.vernostService.editAnscilaries(array).subscribe(response => {
          // console.log("response", response);
          this.dblclick = false;
          this.forupdate = true;

          //this.setlog("EDIT", formData);
          document.getElementById("errs").innerHTML =
            "Record Updated Successfully";


        });
      }
      if (this.Parent_result_ID == "") {
        var DataAncillary = {
          parent_table: this.parent_table,
          dbFields: this.dbFields1,
          formData: formData,
          USER_ID: this.uid,
          PAGENAME: "CITY"
        };

        //call webservice to save data into table

        this.vernostService.insertData(DataAncillary).subscribe(response => {
          if (response[0].status == "success") {
            document.getElementById("errs").innerHTML =
              "Record Created Successfully";
            this.dblclick = false;
            this.viewpage = true;
            this.showList = false;
            this.showApprove = true;

            this.showFormData(response[0].addinfo, 1);

          }
        });
      }
    }
  }

  searchData() {
    this.searchlist = false;
    this.adLoader = true;

    var field1 = this.search_details.TYPE;
    var searchitem = [];
    var searchColumn = [];
    searchitem.push(field1);
    searchColumn.push("TYPE");
    var Data = {
      parent_table: this.parent_table,
      dbFields: searchColumn,
      searchData: searchitem,
      childtables: this.childtables,
      filters: this.filters1
    };
  
    this.vernostService.searchRecord(Data).subscribe(response => {
     
      if (response.length > 0) {
        this.adLoader = false;
        document.getElementById("errs").innerHTML = "";
        this.adSearchtabledata = response;

        this.adSearchresult = true;


      } else {
        this.adLoader = false;
        document.getElementById("errs").innerHTML = "Record Not Found";
        this.adSearchtabledata = [];
        this.adSearchresult = false;
        setTimeout(function () {
          document.getElementById("errs").innerHTML = "";
        }, 5000);
      }
    });

  }
  fileChangeListener($event): void {
    // this.csvupload.fileChangeListen($event, this.parent_table);
  }
  checkIt(data, flag) {
    this.validateNames(data);
    if (flag == 1) {
      this.checkNames();
    }
  }

  submitData1() {
    // console.log("Parent_result_ID", this.Parent_result_ID)

    if (
      this.screen_details.TYPE == "" ||
      this.screen_details.TYPE == undefined ||
      this.screen_details.DESCRIPTION == "" ||
      this.screen_details.DESCRIPTION == undefined
    ) {
      document.getElementById("errs").innerHTML = "Please fill all data";
    } else {
      this.offSubmit = true;
      if (this.actionmode != "Edit") {
        this.checkNames();
      } else {
        this.onEdit_checkName();
      }
    }
  }
  checkNames() {
    if (
      this.screen_details.CITY_CODE != undefined &&
      this.screen_details.CITY_CODE != ""
    ) {
      if (this.actionmode != "Edit") {
        var arrayAncillary = {
          columnName: "CITY_CODE",
          dbFieldName: this.screen_details.CITY_CODE.toUpperCase(),
          parent_table: this.parent_table
        };

        this.vernostService.checkName(arrayAncillary).subscribe(data => {
          if (data[0].status == "Sucess") {
            this.nameExist = false;
            this.codePresent = false;

            if (this.offSubmit) {
              this.checkNames1();
            }
          } else {
            this.nameExist = true;
            this.codePresent = true;
          }
        });
      }
    }
  }

  checkNames1() {
    if (
      this.screen_details.CITY_NAME != undefined &&
      this.screen_details.CITY_NAME != ""
    ) {
      if (this.actionmode != "Edit") {
        var arrayAncillary = {
          columnName: "CITY_NAME",
          dbFieldName: this.screen_details.CITY_NAME,
          parent_table: this.parent_table
        };

        this.vernostService.checkName(arrayAncillary).subscribe(data => {
          if (data[0].status == "Sucess") {
            this.nameExist1 = false;
            this.namePresent = false;
            if (this.offSubmit) {
              this.submitdata();
            }
          } else {
            this.nameExist1 = true;
            this.namePresent = true;
          }
        });
      }
    }
  }

  validateNames(data) {
    if (data.length == 0) {
      this.minlength = false;
    } else {
      if (data.length < 3) {
        this.minlength = true;
      } else {
        this.minlength = false;
      }
    }
  }

  checkIt1(dataAncillaryparams) {
    if (dataAncillaryparams.length == 0) {
      this.minlength1 = false;
    } else {
      if (dataAncillaryparams.length < 3) {
        this.minlength1 = true;
      } else {
        this.minlength1 = false;
      }
    }
  }

  checkLength1(dataAncillaryparams) {
    this.exceedLength1 = false;
    this.minlength1 = false;
    this.notAlphabet1 = false;

    document.getElementById("errs").innerHTML = "";
    // var checkAlphabet = new RegExp("/^[A-Za-z]+$/").test(this.data);
    var regx = /^[A-Za-z]+$/;
    var checkAlphabet = regx.test(dataAncillaryparams);

    if (dataAncillaryparams.length == 0) {
      this.minlength1 = false;
      this.exceedLength1 = false;
      this.notAlphabet1 = false;
    } else {
      if (dataAncillaryparams.length > 3) {
        this.exceedLength1 = true;
        this.minlength1 = false;
      } else {
        this.exceedLength1 = false;
      }
      if (!checkAlphabet) {
        this.notAlphabet1 = true;
      } else {
        this.notAlphabet1 = false;
      }
    }
  }

  checkLength(dataAncillaryparams) {
    this.exceedLength = false;
    this.minlength = false;
    this.notAlphabet = false;
    this.codePresent = false;
    this.nameExist = false;

    document.getElementById("errs").innerHTML = "";
    // var checkAlphabet = new RegExp("/^[A-Za-z]+$/").test(this.data);
    var regx = /^[A-Za-z]+$/;
    var checkAlphabet = regx.test(dataAncillaryparams);

    if (this.actionmode == "Edit") {
      this.isApproved = false;
    }

    if (dataAncillaryparams.length == 0) {
      this.minlength = false;
      this.exceedLength = false;
      this.notAlphabet = false;
    } else {
      if (dataAncillaryparams.length > 3) {
        this.exceedLength = true;
        this.minlength = false;
      } else {
        this.exceedLength = false;
      }
      if (!checkAlphabet) {
        this.notAlphabet = true;
      } else {
        this.notAlphabet = false;
      }
    }
  }

  hidemsg() {
    if (this.nameExist == false) {
      document.getElementById("errs").innerHTML = "";
    }
  }
  checkCityName(dataAncillaryparams) {
    this.namePresent = false;
    this.onlyspclchar = false;
    this.onlyspaces = false;
    this.data_present = false;
    this.nameExist1 = false;

    document.getElementById("errs").innerHTML = "";
    // if (this.nameExist == false) {
    //   document.getElementById("errs").innerHTML = "";
    // }
    this.onlynum = false;
    if (dataAncillaryparams.length == 0) {
      this.mincityname = false;
      this.cnameExceed = false;
      this.invalidCityName = false;
      this.onlyspaces = false;
    } else {
      if (this.actionmode == "Edit") {
        this.isApproved = false;
      }
      if (dataAncillaryparams.length >= 2) {
        this.mincityname = false;
      }
      var regx = /^[^-\s][a-zA-Z0-9"!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~"\s]{0,125}$/;

      //  ^[^-\s][a-zA-Z0-9_\s-]+$
      var checkname = regx.test(dataAncillaryparams);
      if (dataAncillaryparams.length > 125) {
        this.cnameExceed = true;
      } else {
        this.cnameExceed = false;
        if (!checkname) {
          this.invalidCityName = true;
        } else {
          this.invalidCityName = false;
        }
      }
    }
  }

  check_valiid_Names() {
    if (this.actionmode != "Edit") {
      if (this.nameExist && this.screen_details.CITY_CODE.length > 0) {
        document.getElementById("errs").innerHTML = "City code already exist";
      }
      if (this.nameExist1 && this.screen_details.CITY_NAME.length > 0) {
        document.getElementById("errs").innerHTML = "City name already exist";
      }
    }
  }

  onEdit_checkName() {
    if (this.actionmode == "Edit") {
      // this.data_present = true;
      var code = this.screen_details.CITY_CODE;
      var name = this.screen_details.CITY_NAME;
      var table = this.parent_table;
      var column = "CITY_NAME";
      var column1 = "CITY_CODE";
      let arrayAncillary = {
        code: code,
        name: name,
        table: table,
        column: column,
        column1: column1
      };

      this.vernostService.checkRecordName(arrayAncillary).subscribe(data => {
        if (data[0].status == "success") {
          this.data_present = true;
          this.nameExist1 = true;
          // document.getElementById("errs").innerHTML = "Record Already Exist";
        } else {
          this.data_present = false;
          if (this.offSubmit) {
            this.submitdata();
          }
        }
      });
    }
  }

  onBlurCity(arrayAncillary) {
    this.onEdit_checkName();

    if (arrayAncillary.length == 0) {
      this.mincityname = false;
      this.onlynum = false;
      this.onlyspaces = false;
    } else {
      if (arrayAncillary.length < 3) {
        this.mincityname = true;
      } else {
        this.mincityname = false;
        var regx = /(?!^\d+$)^.+$/;
        var onlyNumber = regx.test(arrayAncillary);

        var space_reg = /^[ ]+$/;
        var onlyspace = space_reg.test(arrayAncillary);
        if (onlyspace) {
          // this.onlyspaces = true;
        }

        if (!onlyNumber) {
          this.onlynum = true;
        } else {
          this.onlynum = false;
        }

        var regsx = /^[!@#$%^&*(),.?":{}|<>]+$/;
        var onlyspecialchar = regsx.test(arrayAncillary);

        if (onlyspecialchar) {
          this.onlyspclchar = true;
        } else {
          this.onlyspclchar = false;
        }
      }
    }
  }


  clearRemark() {
    this.minRemark = false;
    this.aprove_details.APPROVAL_REMARKS = "";
  }
  checkRemarkLength(arrayAncillary) {
    if (arrayAncillary.length < 3) {
      this.minRemark = true;
    } else {
      this.minRemark = false;
    }
  }

  getremark(val) {
    this.minRemark = false;
    if (val == undefined || val == "" || val.length < 3) {
      this.aprvbtn = false;
    } else {
      this.aprvbtn = true;
    }
  }
}

